export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-unlink-8bb21274d2501ec04044857556374c77.svg";